var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Rename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53192 14.1034L15.6357 2.99957C15.6708 2.96476 15.7277 2.96463 15.7628 2.99957L21.0005 8.23727C21.0354 8.27233 21.0353 8.32919 21.0005 8.36433L9.89667 19.4681C9.70008 19.6647 9.44576 19.7928 9.17092 19.8348L3.7668 20.6607C3.51668 20.6989 3.30117 20.4833 3.33936 20.2332L4.16524 14.8291C4.20723 14.5543 4.33533 14.2999 4.53192 14.1034Z",
    stroke: "#6B7380",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1553 6.48093L12.7463 4.88994L19.1102 11.2539L17.5192 12.8449L11.1553 6.48093Z",
    fill: "#6B7380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Rename);
export default __webpack_public_path__ + "static/media/24_Rename.b19d54a5c9b5f0dc63d4cc64d6c5d298.svg";
export { ForwardRef as ReactComponent };